<template>
  <div class="mt-20">
    <!-- <Aboutplay /> -->
    <PlayVideo />
    <!-- <div
      v-if="selectedList"
      class="fixed bottom-0 left-0 w-full bg-white shadow-lg h-full"
    >
      <iframe
        style="border-radius: 12px"
        :src="selectedList.link"
        width="100%"
        height="100%"
        scrolling="no"
        frameborder="0"
        allowfullscreen=""
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      ></iframe>
    </div> -->
  </div>
</template>
<script>
// import Aboutplay from "./components/Aboutplay.vue"
import { mapState } from "vuex";
import PlayVideo from "./Playvideos.vue";
export default {
  components: {
    // Aboutplay,
    PlayVideo,
  },
  // computed: {
  //   ...mapState("cms", { selectedList: "selectedList" }),
  // },
};
</script>

<style>
#player {
  z-index: 9999;
  border-top: 1px solid #e2e8f0;
  justify-self: center;
}

</style>
